var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-indicator"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.dots),function(_){return [_vm._v(".")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }